import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "./Routes";
import { useEnvironment } from "../context/useEnv";

export default function ClientRouter({ hydrationData }: { hydrationData: Record<string, any> }) {
    const url = new URL(window.location.href);

    window.__client_context = {
        env: {
            ...window.__env,
            development: String(url.host).includes('127.0.0.1') || String(url.host).includes('localhost')
        },
        info: window.__user_info
    }

    const clientRouter = createBrowserRouter(routes, {
        hydrationData, window
    })

    return (
        <RouterProvider router={clientRouter} />
    )
}